export default __webpack_public_path__ + "static/zois-solid-8783e21f5148acbe8fc9c4960126df8c.svg";